import * as yup from "yup";
import { validationNotEmpty, } from "./defaultValidations";

export default yup.object({
    password: validationNotEmpty("Password"),
    confirmPassword: validationNotEmpty("Confirm Password"),
});